import { Link as RouterLink } from 'react-router-dom';

const NoPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-6">
      <div className="max-w-xl w-full text-center">
        <div className="mb-6">
          <h1 className="text-6xl font-extrabold text-gray-900 tracking-tight">404</h1>
          <p className="mt-2 text-lg font-medium text-gray-700">Page not found</p>
        </div>
        <p className="text-sm font-medium text-gray-800 mb-8">
          The page you’re looking for doesn’t exist or was moved. Try going back to your Knowledge
          dashboard.
        </p>
        <div className="flex items-center justify-center gap-3">
          <RouterLink
            to="/knowledge"
            className="px-5 py-2.5 rounded-lg bg-gray-900 text-white text-sm font-bold hover:bg-gray-800"
          >
            Go to Knowledge
          </RouterLink>
          <RouterLink
            to="/"
            className="px-5 py-2.5 rounded-lg border border-gray-400 text-sm font-semibold text-gray-900 hover:bg-gray-100"
          >
            Home
          </RouterLink>
        </div>
      </div>
    </div>
  );
};

export default NoPage;
